import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { useEffect, useRef, useState } from "react";
import { initEvents, initialize } from "./slideshow";
import { Link, useLocation } from "react-router-dom";
import { domain } from "config.js";

import QuestionBox from "../InfoPages/PageContent/QuestionBox";
import PinkForm from "../InfoPages/PageContent/PinkForm";
import Footer from "../InfoPages/PageContent/Footer";
import BackButton from "../Components/BackButton";

import CTAButton from "../InfoPages/PageContent/CTAButton";

const questionBoxData = {
    title: "ECHT INTERESSE? WORD DAN GRATIS +PLAN LID EN ONTVANG ALLE VOLLEDIGE INFORMATIE",
    text: ["Plattegronden | Actuele Prijzen | Actuele Beschikbaarheid | Uitgebreide Omschrijvingen | Locatie | video's | Live Videotours"],
    button: "SCROLL NAAR HIERONDER EN WORD +PLAN LID"
}

function ShowSpecific({ ImageCache, title }) {
    const [params, setParams] = useState({});

    var ref = new URLSearchParams(useLocation().search).get("ref");

    function loadProperty() {
        fetch(domain + "/int-search", { method: "POST", body: JSON.stringify({ ref }) }).then(async (response) => {
            var prms = {};
            try {
                prms = (await response.json())[0][ref];
                prms = prms ? prms : {};
            } catch { }
            setParams(prms);
        })
    }

    async function getSlideShowImages() {
        var images = [];
        try {
            var response = await fetch(domain + "/int-getFiles", { method: "POST", body: JSON.stringify({ ref, type: "slideshow" }) });
            images = (await response.json());
            console.log("Images - ", images);
            images = images ? images : [];
        } catch (e) {
            console.log(e.message)
        }

        return images;
    }

    useEffect(() => {
        if (ImageCache.images.slideshow[ref]?.length > 0) initialize(ImageCache.images.slideshow[ref]);//{ "imageCounter": imageCounter.current, "noofpics": noofpics.current, "frame1": frame1.current, "frame2": frame2.current, "frame3": frame3.current, "inner1": inner1.current, "inner2": inner2.current, "inner3": inner3.current })
        // }, [ImageCache.images.slideshow[ref]]);
    }, [ImageCache.images.slideshow[ref]]);

    useEffect(() => {
        initEvents();
        document.title = title;
    }, [title])

    useEffect(() => {
        loadProperty();

        async function loadImages() {
            if (!ImageCache.images.slideshow[ref]) {
                var imgList = await getSlideShowImages();
                if ((!imgList) || imgList.length < 1) return;

                var images = { ...ImageCache.images };
                images.slideshow[ref] = imgList;
                ImageCache.setImages(images);
            }
        }

        loadImages();
    }, [ImageCache.images.slideshow[ref]]);

    return (
        <>
            <div className="bilbilan">

                {/*Cache Images first*/}
                <div>
                    {ImageCache.images.slideshow[ref]?.map(image => {
                        return (<div key={image} style={{ backgroundImage: `url("${image}")` }} />)
                    })}
                </div>

                <div className="slide-page-header">
                    <h1 className="text-center">REF-{ref}/{params.location}/{params.type}/{params.bedrooms} Bed{params.bedrooms > 1 ? "s" : ""}/{monetize(params.price)}</h1>
                </div>

                <div className="slide-contents">
                    <div className="slide-anim-cont">
                        <div className="frame-1 position-1" >
                            <div className="inner_1 size-bg" ></div>
                        </div>
                        <div className="frame-2 position-2" >
                            <div className="inner_2 size-fit" ></div>
                        </div>
                        <div className="frame-3 position-3" >
                            <div className="inner_3 size-fit" ></div>
                        </div>
                    </div>

                    <div className="container-fluid btn-container">
                        <div className="row no-gutters btns mb-md-3 mb-sm-3 ml-md-3 ml-xl-0">
                            <div className="col-1 offset-1 offset-xl-8">
                                <h2 className="counter-txt"><span id="image-counter" className="counter-txt" >1</span>/<span className="counter-txt" id="no-of-pics" >&nbsp;</span></h2>
                            </div>
                            <div className="col-3 col-lg-1 col-sm-2 offset-sm-7 offset-6 offset-lg-7 offset-xl-2">
                                <div className="d-flex flex-row justify-content-between" style={{ width: "90px" }}>
                                    <button className="btn btn-outline-secondary slide-left slidebuttons d-flex align-items-center">
                                        <FaAngleLeft size={29} />
                                    </button>
                                    <button className="btn btn-outline-secondary slide-right slidebuttons d-flex align-items-center" >
                                        <FaAngleRight size={29} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row" style={{ marginTop: "-30px" }}>
                    <div className="col-12 d-flex justify-content-end">
                        <div className="showspecific-right-space-cnt d-flex flex-column align-items-center">
                            <CTAButton position="relative" style={{ right: "unset", bottom: "unset" }} />
                        </div>
                    </div>
                    <div className="col-lg-8 col-12 ml-3 order-first order-lg-0 justify-content-end d-flex" style={{ height: "57px", marginTop: "30px" }}>
                        <BackButton className="mx-auto mx-lg-0 mt-2 " />
                    </div>
                    <div className="col-12 col-sm-10 col-md-8 part-3 showspecific-description">
                        <div className="row ml-lg-5 ml-md-5 ml-sm-2">
                            <div className="col">
                                {sessionStorage.getItem("hideCTA") && <div className="spacer"></div>}
                                {/* <div className="showspecific-spacer"></div> */}
                                <h2>OMSCHRIJVING</h2>
                            </div>
                        </div>
                        <div className="row ml-lg-5 ml-md-5 ml-sm-2">
                            <div className="col-5">
                                <hr className="part-3-hr-1" />
                            </div>
                        </div>
                        <div className="row ml-lg-5 ml-sm-2 ml-md-5">
                            <div className="col-3">
                                <hr className="part-3-hr-2" />
                            </div>
                        </div>
                        <br />
                        <div className="row ml-sm-2 ml-lg-5 ml-md-5">
                            <div className="col">
                                <p>
                                    {params.description}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-4">
                        <div className="showspecific-fancy-text-cnt d-flex flex-column align-items-center">
                            <div className="showspecific-fancy-text-verline"></div>
                            <p className="showspecific-fancy-text">"laat hieronder vrijblijvend al<br /> Uw gegevens na.<br /> Wij contacteren u zo snel mogelijk terug."</p>
                            <div className="showspecific-fancy-text-verline"></div>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <br />
            <QuestionBox data={questionBoxData} />
            <PinkForm />
            <Footer />

            {/* <div className="row no-gutters">
                <div className="col m-auto">
                    <h1 className="text-center" style={{ textDecoration: "none", marginTop: "30px" }}><Link to="/results">&#60; Go Back</Link></h1>
                </div>
            </div> */}
        </>
    );
}

function monetize(x) {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " €";
}

export default ShowSpecific;